type CodeBlockTextLine = {
  children?: Array<{ text?: string }>;
};

const ZWSP = "\u200B";
const SENTINEL_TOKEN = "__LINE__MARK__UNIQUE_8f3b__";
const LINE_MARK = ZWSP + SENTINEL_TOKEN + ZWSP;

export function convertCodeBlockContentToString(codeblockContent: unknown): string {
  if (typeof codeblockContent === "string") return codeblockContent;
  let codeBlockContentStr = "";
  const lines = codeblockContent as CodeBlockTextLine[] | null | undefined;
  if (lines && Array.isArray(lines)) {
    for (let i = 0; i < lines.length; i++) {
      const row = lines[i];
      if (row) {
        let codeFontStr = "";
        const codeFontArr = row.children || [];
        if (codeFontArr.length > 1) {
          for (let j = 0; j < codeFontArr.length; j++) {
            codeFontStr += codeFontArr[j].text ?? "";
          }
          codeBlockContentStr += codeFontStr + (i < lines.length - 1 ? "\n" : "");
        } else {
          const innerText =
            codeFontArr[0] && typeof codeFontArr[0].text === "string" ? codeFontArr[0].text : "";
          codeBlockContentStr += innerText + (i < lines.length - 1 ? "\n" : "");
        }
      }
    }
  }
  return codeBlockContentStr;
}

function insertSentinels(code: string, lineMark: string): string {
  return String(code).replace(/\n/g, "\n" + lineMark);
}

function normalizeEscapedToken(html: string, token: string): string {
  const escapedToken = token.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  return html.split(escapedToken).join(token);
}

function injectSRLabels(htmlWithToken: string, token: string, startLine: number): string {
  const cleanedHtml = htmlWithToken.split(ZWSP).join("");
  const parts = cleanedHtml.split(token);
  const start = Number.isFinite(Number(startLine)) ? Number(startLine) : 1;
  const makeLabel = (n: number) => '<span class="screen-reader-only">Line ' + n + "</span>";
  return parts
    .map((chunk, idx) => {
      const label = makeLabel(start + idx);
      return label + chunk;
    })
    .join("");
}

export function prepareCodeForLineHighlight(code: string): string {
  return insertSentinels(code, LINE_MARK);
}

export function postProcessLineHighlightedHtml(html: string, startLine: number): string {
  const normalized = normalizeEscapedToken(html, SENTINEL_TOKEN);
  return injectSRLabels(normalized, SENTINEL_TOKEN, startLine);
}
